import { Box, Divider, Heading, HStack, VStack } from '@chakra-ui/react';
import { Icon, IconMap } from '@common/components/Icon';
import { usePropertiesModel } from '@common/models/PropertiesModel';
import { FontFamily } from '@common/theming/Fonts';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';

type GeneralInfoProps = {
  children?: React.ReactNode;
};

export const GeneralInfo: React.FC<GeneralInfoProps> = () => {
  const { property } = usePropertiesModel();
  const beds = Number(property?.sfr?.info.beds ?? 0);
  const bedLabel = beds > 1 ? `${beds} Beds` : `${beds} Bed`;
  const baths = Number(property?.sfr?.info.baths ?? 0);
  const bathLabel = baths > 1 ? `${baths} Baths` : `${baths} Bath`;
  const sqft = property?.sfr?.info.sqft ?? 0;
  const sqftLabel = `${sqft} sq. ft.`;
  const address = `${property?.sfr?.info.address}, ${property?.sfr?.info.city}, ${property?.sfr?.info.state} ${property?.sfr?.info.zip}`;
  return (
    <VStack alignItems={'flex-start'}>
      {/* Title */}
      <Heading fontFamily={FontFamily.HELVETICA_NOW_BOLD} fontWeight="normal" fontSize={['32px', '40px']}>
        {property?.display_name}
      </Heading>
      {/* Tags */}
      <HStack flexWrap="wrap" gap={['2px', '2px', '10px']} pb="20px">
        {Boolean(beds) && <InfoTag icon="bed-front" text={bedLabel} />}
        {Boolean(baths) && <InfoTag icon="bath" text={bathLabel} />}
        {Boolean(sqft) && <InfoTag icon="ruler-triangle" text={sqftLabel} />}
      </HStack>
      {/* Address */}
      <TextBlock color="gray.600" fontSize="20px" lineHeight={'24px'} style={{ marginTop: 0 }}>
        {address}
      </TextBlock>
      {/* Divider */}
      <Box py="40px" w="100%">
        <Divider />
      </Box>
      {/* Description */}
      <TextBlock fontSize={['16px', '20px']} whiteSpace={'pre-wrap'}>
        {property?.description}
      </TextBlock>
    </VStack>
  );
};

const InfoTag: React.FC<{ icon: keyof typeof IconMap; text: string }> = ({ icon, text }) => {
  return (
    <Box
      display={'flex'}
      alignItems={'center'}
      justifyContent="center"
      bgColor={'gray.50'}
      px="12px"
      borderRadius={'7px'}
      h="34px">
      <Icon color="gray.600" boxSize={['12px', '12px', '20px']} icon={icon} mr="5px" variant={'regular'} />
      <TextBlock color="gray.600" fontSize={['12px', '12px', '20px']}>
        {text}
      </TextBlock>
    </Box>
  );
};
